import React from 'react';
import { useLocation } from 'react-router';
import { Trans } from '@lingui/react/macro';

// Components
import ButtonStyled from '../Button';

export const StripeRedirectPage = () => {
  const { search } = useLocation();
  const status = new URLSearchParams(search).get('status');

  if (status === 'success') {
    return (
      <div style={{ maxWidth: '400px', textAlign: 'center', margin: '0 auto' }}>
        <h3>
          <Trans>Sucessfully subscribed. Click below to continue sign up</Trans>
        </h3>
        <ButtonStyled href="https://app.solve.finance/onboarding/subscription?status=success">
          <Trans>Continue</Trans>
        </ButtonStyled>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '400px', textAlign: 'center', margin: '0 auto' }}>
      <h3>
        <Trans>We were unable to complete your subscription. Click below to return to the app</Trans>
      </h3>
      <ButtonStyled href="https://app.solve.finance/onboarding/subscription?status=cancelled">
        <Trans>Back to App</Trans>
      </ButtonStyled>
    </div>
  );
};
